export const APP_DASHBOARD_V2_ROUTE = "/dashboard"